/**
 * header-slider.js
 * -----------------
 * Initialise the hero carousel on `.page-header-sliders` using Slick.
 * Mirrors the behaviour defined in `components/PageHeaderSliders.vue`.
 *
 * Dependencies (expected to be loaded globally before this script):
 *   – jQuery (window.jQuery / $)
 *   – Slick carousel plugin (`slick.min.js`)
 */


(function ($) {
  'use strict';

  function initHeaderSlider() {
    const $slider = $('.page-header-sliders__slick');

    if (!$slider.length || typeof $.fn.slick === 'undefined') return;
    if ($slider.hasClass('slick-initialized')) return;

    $slider.slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnHover: false,
      pauseOnFocus: false,
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">Previous</button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next">Next</button>',
      customPaging() {
        return '<div class="custom-dot"></div>';
      },
    });
  }

  jQuery(document).ready(initHeaderSlider);

 // 2️⃣ Watch for DOM changes (handles AJAX filter reloads)
  const observer = new MutationObserver(() => {
    const slider = document.querySelector('.page-header-sliders__slick');
    if (slider && !$(slider).hasClass('slick-initialized')) {
      setTimeout(initHeaderSlider, 300);
    }
  });

  const main = document.querySelector('main') || document.body;
  if (main) {
    observer.observe(main, { childList: true, subtree: true });
  }

  // 3️⃣ Safety: re-init when Shopify reloads a section
  document.addEventListener('shopify:section:load', initHeaderSlider);
  document.addEventListener('shopify:section:reloaded', initHeaderSlider);

})(jQuery);
